import { apiCallback } from 'api';
import { ApiCallArgs } from 'api/types';
import { ApiError } from 'constants/errors';
import { Eligibility, SearchTermsResponse, SuggestionsResponse } from './types';

const SEVEN_SECONDS = 7 * 1000;
const FIFTEEN_SECONDS = 15 * 1000;
const TWENTY_SECONDS = 20 * 1000;

const eligibilityDefinition = {
  service: 'intelligent-shopping-experience',
  endpoint: 'eligibility',
  verbs: ['get'],
  defaultVersion: 1,
  timeout: {
    response: SEVEN_SECONDS,
    deadline: SEVEN_SECONDS,
  },
};

const searchTermsDefinition = {
  service: 'intelligent-shopping-experience',
  endpoint: 'search-terms',
  verbs: ['post'],
  defaultVersion: 1,
  timeout: {
    response: TWENTY_SECONDS,
    deadline: TWENTY_SECONDS,
  },
};

const suggestionsDefinition = {
  service: 'intelligent-shopping-experience',
  endpoint: 'suggestions',
  verbs: ['post'],
  defaultVersion: 1,
  timeout: {
    response: SEVEN_SECONDS,
    deadline: FIFTEEN_SECONDS,
  },
};

const getEligibilityCallback = apiCallback(eligibilityDefinition, 'get');

const getEligibility = (args: ApiCallArgs): WtrApiCall<Promise<Eligibility | ApiError>> =>
  getEligibilityCallback(args);

const getSearchTermsCallback = apiCallback(searchTermsDefinition, 'post');

const getSearchTerms = (args: ApiCallArgs): WtrApiCall<Promise<SearchTermsResponse | ApiError>> =>
  getSearchTermsCallback(args);

const getSuggestionsCallback = apiCallback(suggestionsDefinition, 'post');

const getSuggestions = (args: ApiCallArgs): WtrApiCall<Promise<SuggestionsResponse | ApiError>> =>
  getSuggestionsCallback(args);

export default {
  getEligibility,
  getSearchTerms,
  getSuggestions,
};
